import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { Grid } from "@material-ui/core";
import { HeaderData } from "./components/HeaderData";
import { BilletTempChart } from "./components/charts/billet-temp/BilletTempChart";
import { MoldLevelChart } from "./components/charts/mold-level/MoldLevelChart";
import { StrandSpeedChart } from "./components/charts/strand-speed/StrandSpeedsChart";
import { ProbesTable } from "./components/tables/probes-table/ProbesTable";
import { ProductionTable } from "./components/tables/production-table/ProductionTable";
import { ScrapTable } from "./components/tables/scrap-table/ScrapTable";
import { StrandTable } from "./components/tables/strand-table/StrandTable";

export const CasterProcessData = () => {
	const {
		state: { casProcessData },
	} = useHeatReportContext();
	return (
		<>
			<Grid item xs={12} container spacing={2} justifyContent="center">
				<HeaderData key={casProcessData.ProcessId} />
			</Grid>

			<Grid item xs={12} container spacing={1} justifyContent="center">
				<Grid item xs={3}>
					<ProbesTable key={casProcessData.ProcessId} />
				</Grid>

				<Grid item xs={3} container spacing={1}>
					<Grid item xs={12}>
						<ProductionTable key={casProcessData.ProcessId} />
					</Grid>
					<Grid item xs={12}>
						<ScrapTable key={casProcessData.ProcessId} />
					</Grid>
				</Grid>
				<Grid item xs={6}>
					<StrandTable key={casProcessData.ProcessId} />
				</Grid>
				<Grid item xs={12} container spacing={1}>
					<Grid item xs={4} style={{ paddingRight: "8px" }}>
						<StrandSpeedChart key={casProcessData.ProcessId} />
					</Grid>
					<Grid item xs={4} style={{ marginLeft: "-4px" }}>
						<MoldLevelChart key={casProcessData.ProcessId} />
					</Grid>
					<Grid item xs={4}>
						<BilletTempChart key={casProcessData.ProcessId} />
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};
